import { LOCALES } from '../locales';

export default {
	[LOCALES.ENGLISH]: {
		'hello': 'Hello, {name}!',
		'TÜM TERMİNALLER':'ALL TERMINALS',
		'BÖLÜM BAZINDA': 'DEPARTMENT BASED',
        'FİLTRE BAZINDA': 'ON FILTER BASE',
		'Bildiren':'Declarative',
        'Renk':'Color',
        'Sicil':'Registry',
        'Parça':'Piece',
        'Hata':'Defect',
        'Saat':'Hour',
        'Hata Türü':'Defect Type',
        'Hata Sor':'Defect Res',
        'Alt Sorumlu':'Lower Res',
        'Kaydet':'Save',
        'İşlem':'Process',
        'MONTAJ NO': 'ASSEMBLY NO',
		'BODY NO': 'BODY NO',
		'ARA': 'SEARCH',
		'Teknik Destek': 'Technical Support',
		'ARAÇ LİSTESİ': 'Vehicle List',
		'MANUEL HATA': 'Manual Defect',
		'ÇOKLU HATA': 'Multiple Defects',
		'HATA LİSTESİ': 'Defect List',
		'HATA KOPYA': 'Copy Defect',
		'ÇIKIŞ': 'EXIT',
		'Toplam satır': 'Total row',
		'HATA GİRİŞ EKRANI': 'DEFECT ENTRY SCREEN',
		'HIZLI KAYDET': 'QUICK SAVE',
		'KAYDET VE GEÇ': 'SAVE AND CONTINUE',
		'HATA KAYIT': 'Defect LOG',
		'ARA': 'SEARCH',
		'TERMİNAL İLK RESMİ': 'FIRST IMAGE OF TERMINAL',
		'SIK GELEN HATA': 'FREQUENT Defect',
		'MANİFEST': 'MANIFEST',
		'ÇIKIŞ': 'EXIT',
		'MODEL İLK RESMİ': 'FIRST IMAGE OF MODEL',
		'GERİ': 'BACK',
		'HATA LİSTESİ': 'Defect LIST',
		'TEMİZLE': 'CLEAR',
		'BÜYÜK FONT': 'LARGE FONT',
		'Harigami': 'Harigami',
		'Tarih': 'Date',
		'Terminal Listesi': 'Terminal List',
		'Sicil No': 'Employee Id',
		'Şifre': 'Password',
		'Giriş Yap': 'Login',
		'Kapat': 'Close',
		'Montaj':'Assembly No',
		'Vardiya':'Shift',
        'Girdiğiniz bilgiler hatalıdır!':'The information you entered is incorrect!',
		'Giriş yapılıyor...':'Signing in...',
		'Açıklama': 'Description',
		'Alt Sorumlu': 'Subordinate',
		'Yapılan İşlem': 'Operation Performed',
		'Çıkış Departmanı': 'Exit Department',
		'Hata Sınıfı': 'Defect Class',
		'Sık Gelen Hata': 'Common Defect',
		'Hata Sorumlusu': 'Defect Responsible',
		'Kaydedildi': 'Saved',
		'Örnek açıklama': 'Example Description',
		'İptal': 'Cancel',
		'RENK':'COLOR',
	}
}